module.exports = __webpack_public_path__ + "img/49.61bc13e8.webp";